import styled from 'styled-components';

interface StyledProps {
  isVisible: boolean;
}

export const MapBox = styled.div<StyledProps>`
  width: 112px;
  height: 112px;
  pointer-events: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
  display: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
`;
